export const ADD_WIDGET = "addWidget";
